import $ from "jquery"
import "slick-carousel-latest"
import "jquery-match-height";

$('.js-systems-slider').on('init', function(event, slick){
    $('.js-systems-matchheight').matchHeight();
});

$('.js-systems-slider').slick({
    slidesToShow: $('.js-systems-slider').data('slider-limit'),
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        }
    ]
});

$('.js-systems-slider').on('afterChange', function(event, slick, currentSlide){
    $('.js-systems-matchheight').matchHeight();
});

/**
 * Testimonial Slider Counter
 */
let slickTestimonials = $('.js-slider-testimonials');
let slickTestimonialsCounter = $('.js-testimonials-counter');

slickTestimonials.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
  let i = (currentSlide ? currentSlide : 0) + 1;
  slickTestimonialsCounter.text(i + '/' + slick.slideCount);
});

slickTestimonials.slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: false,
  autoplay: true,
  autoplaySpeed: 15000,
  prevArrow: $('.testimonials__navigation .testimonials-prev'),
  nextArrow: $('.testimonials__navigation .testimonials-next'),
});